import {
  PiNumberCircleFour,
  PiNumberCircleOne,
  PiNumberCircleThree,
  PiNumberCircleTwo,
} from "react-icons/pi";
import React from "react";
import { MdInstallMobile, MdOutlineAccountCircle } from "react-icons/md";
import { TiMicrophone } from "react-icons/ti";

interface StepProps {
  title: string;
  children: React.ReactNode;
  icon: React.ReactNode;
  number: number;
  className?: string;
}

function Step({ title, children, icon, number }: StepProps) {
  const getNum = (i: number) => {
    const className = "relative text-primary shadow-2xl ";
    const size = 40;
    switch (i) {
      case 1:
        return <PiNumberCircleOne size={size} className={className} />;
      case 2:
        return <PiNumberCircleTwo size={size} className={className} />;
      case 3:
        return <PiNumberCircleThree size={size} className={className} />;
      case 4:
        return <PiNumberCircleFour size={size} className={className} />;
    }
  };
  return (
    <div
      className={`basis-[100%] backdrop-blur-xl bg-on_primary bg-opacity-70 text-primary max-w-sm flex flex-col items-center p-5 m-5 rounded-3xl shadow-2xl`}
    >
      {getNum(number)}
      <h1 className="text-2xl font-bold text-center mt-3">{title}</h1>
      <div className="p-5">{icon}</div>
      <p className="text-center">{children}</p>
    </div>
  );
}

function GettingStarted() {
  return (
    <div
      id="getting-started"
      className="w-full md:p-5 pb-5 text-primary flex flex-col items-center bg-gradient-to-tl from-orange-700 to-orange-500"
    >
      <h1
        className="text-center text-6xl md:text-8xl p-10 mb-5  text-white"
        style={{ textShadow: "10px 10px 20px black;" }}
      >
        Let's get going.
      </h1>
      <p className="text-center text-2xl text-white pb-10">
        It only takes a few simple steps to start enjoying the benefits of
        PlayGuru. <br /> Follow the steps below and enjoy!
      </p>
      <div className="flex flex-col lg:flex-row">
        <Step
          title={"Download PlayGuru"}
          number={1}
          icon={<MdInstallMobile size={100} />}
          className={"bg-gradient-to-b from-purple-600 to-purple-900"}
        >
          Download PlayGuru from the App Store or Google PlayStore. Note that
          the app is still in beta, so for iOS you'll need to install the
          TestFlight app from Apple in order to install PlayGuru.
        </Step>
        <Step
          title={"Create account"}
          number={2}
          icon={<MdOutlineAccountCircle size={100} />}
          className={"bg-gradient-to-b from-green-500 to-green-700"}
        >
          Create an account in the PlayGuru app. When you open the app for the
          first time you'll be asked to log in. On the same page there will be a
          button to sign up and create a new account.
        </Step>
        <Step
          title={"Allow microphone access"}
          number={3}
          icon={<TiMicrophone size={100} />}
          className={"bg-gradient-to-b from-indigo-400 to-indigo-700"}
        >
          PlayGuru needs permissions to the microphone in order to hear you.
          Give PlayGuru access in the settings if you haven't already. Don't
          worry, no audio will leave your device!
        </Step>
        {/*<Step*/}
        {/*  title={"Start exercising"}*/}
        {/*  number={4}*/}
        {/*  icon={<GiStrong size={100} />}*/}
        {/*  className={"bg-gradient-to-b from-pink-600 to-pink-900"}*/}
        {/*>*/}
        {/*  You're now ready to start exercising! Pick an exercise from the*/}
        {/*  catalog and have fun!*/}
        {/*</Step>*/}
      </div>
    </div>
  );
}

export default GettingStarted;
